// 锁定webview，隐藏标题栏，显示右上角更多和关闭按钮
/* eslint-disable */
function hideNav () {
  return new Promise((resolve, reject) => {
    window.cordova.exec(() => {
      console.log('隐藏标题栏成功')
      resolve()
    }, () => {
      console.log('隐藏标题栏失败')
      reject()
    }, 'MideaCommon', 'hideNav', null)
  })
}

function setBounces () {
  return new Promise((resolve, reject) => {
    window.cordova.exec((data) => {
      console.log('锁死webview成功')
      resolve(data)
    }, () => {
      console.log('锁死webview失败')
      reject()
    }, 'MideaCommon', 'setBounces', [0])
  })
}

// 右上角按钮，暂时不用

// function navigationRightButtons () {
//   return new Promise((resolve, reject) => {
//     window.cordova.exec((data) => {
//       console.log('显示右上角更多按钮和关闭按钮成功')
//       resolve(data)
//     }, () => {
//       console.log('显示右上角更多按钮和关闭按钮失败')
//       reject()
//     }, 'MideaCommon', 'navigationRightButtons', [1])
//   })
// }

function contentCenterCordovaReady () {
  return new Promise(function (resolve, reject) {
    document.addEventListener('deviceready', function () {
      hideNav().then(() => {
        setBounces()
        resolve()
      })
        .catch(err => {
          reject(err)
        })
    }, false)
  })
}

// 获取AppKey
function getDeviceInfo () {
  return new Promise((resolve, reject) => {
    window.cordova.exec((success) => {
      console.log(JSON.stringify(success))
      resolve()
    }, (error) => {
      console.log("getDeviceInfo Error:" + JSON.stringify(error))
      reject()
    }, 'MideaCommon', 'getDeviceInfo', [])
  })
}

export default { contentCenterCordovaReady, setBounces, getDeviceInfo }
